var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#346fce",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 18.706l.956 1.797a4.369 4.369 0 01-1.806 5.908l-.124.066a4.369 4.369 0 01-5.909-1.806l-3.223-6.062a4.369 4.369 0 011.592-5.787l-.956-1.797a4.369 4.369 0 011.807-5.908l.124-.066a4.369 4.369 0 015.908 1.806l3.223 6.062a4.369 4.369 0 01-1.591 5.787zm0 0l-2.267-4.265a4.369 4.369 0 00-5.908-1.806l-.124.065c-.073.04-.145.08-.215.122l2.268 4.265a4.369 4.369 0 005.908 1.806l.124-.065c.073-.04.145-.08.215-.122z",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtm);
export default __webpack_public_path__ + "static/media/atm.cfc519957982a8a8f96bb333edc28280.svg";
export { ForwardRef as ReactComponent };